import { PageContainer } from '@/components/organisms'
import { DynamicColumnTable } from '@/components/organisms'
import { useQuery } from '@tanstack/react-query'
import { getTierStores } from '@/services/ClubPlus/TierService'
import { useMemo, useState } from 'react'
import { SIZE } from '@/utils/constants/globalStyle'
import { useIntl } from 'react-intl'

const INIT_FILTER = {
  lastUpdated: '',
  storeId: ''
}

export const TierTab = ({ tierID }) => {
  const [selectedStores, setSelectedStores] = useState([])
  const [search, setSearch] = useState(() => INIT_FILTER)
  const searchParams = search?.lastUpdated || search?.storeId ?
    `?storeId=${search?.storeId || ''}&lastUpdated${search?.lastUpdated || ''}` : ''

  const { formatMessage } = useIntl()
  const { data, isLoading } = useQuery({
    queryKey: ['tier-stores', tierID, searchParams],
    queryFn: () => getTierStores(tierID, searchParams),
  })

  const stores = data?.stores ?? []

  const columns = useMemo(() => [
    {
      columnKey: 'storeId',
      name_of_db_column: 'storeId',
      header: formatMessage({ id: 'CLUB_PLUS.TIER_STORES_TABLE_STORE_ID_COLUMN' }),
      cellData: ctx => {
        const storeId = ctx?.row?.original?.storeId

        return <span className="ml-4">{storeId}</span>
      },
    },
    {
      name_of_db_column: 'lastUpdated',
      header: formatMessage({ id: 'CLUB_PLUS.TIER_STORES_TABLE_LAST_UPDATED_COLUMN' }),
      cellData: ctx => {
        const lastUpdated = ctx?.row?.original?.lastUpdated
        if (!lastUpdated) return '-'
        return new Date(lastUpdated).toLocaleDateString('en-US', {
          month: 'numeric',
          day: 'numeric',
          year: 'numeric',
        })
      },
    }], [formatMessage])

  const toolbarActionsDisabled = selectedStores.length === 0

  return (
    <PageContainer key={tierID}>
      <DynamicColumnTable
        columns={columns}
        records={stores}
        setRowSelection={(rowsSelection) => {
          if (rowsSelection?.length > 0) {
            const newSelectedStores = rowsSelection.map(row => row?.original?.storeId)
            setSelectedStores(newSelectedStores)
          }
        }}
        isLoading={isLoading}
        totalRowsCount={stores?.length || 0}
        filters={[]}
        toolbarActions={[
          {
            text: formatMessage({ id: 'CLUB_PLUS.TIER_STORES_ADD_STORES' }),
            variant: 'secondary',
            onClick: () => console.log(selectedStores),
            disabled: toolbarActionsDisabled
          },
          {
            text: formatMessage({ id: 'CLUB_PLUS.TIER_STORES_MOVE_STORES' }),
            variant: 'secondary',
            onClick: () => console.log(selectedStores),
            disabled: toolbarActionsDisabled
          },
        ]}
        showFilterToolbar
        showFilterButton
        showColumnFilters
        showGlobalActions
        pageSize={50}
        resetFilterButtonOptions={{
          onFiltersReset: () => {
            setSearch(INIT_FILTER)
          }
        }}
        setSearchArry={(search) => {
          setSearch(oldSearch => ({
            ...oldSearch,
            [search.field]: search.value
          }))
        }}
        size={SIZE.LARGE}
      />
    </PageContainer>
  )
}
